module.exports = __webpack_public_path__ + "static/media/poop copy.55860446.svg";